import { render } from "./Scale.vue?vue&type=template&id=335f2bed&scoped=true"
import script from "./Scale.vue?vue&type=script&lang=ts"
export * from "./Scale.vue?vue&type=script&lang=ts"

import "./Scale.vue?vue&type=style&index=0&id=335f2bed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-335f2bed"

export default script